"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerWidget = void 0;
var tslib_1 = require("tslib");
var SpinnerWidgetStyles_1 = require("./SpinnerWidgetStyles");
var React = tslib_1.__importStar(require("react"));
var SpinnerWidget = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, size = _a.size, style = _a.style;
    var extraClassName = className ? ' ' + className : '';
    var sizeClassName = size ? ' ' + size : '';
    return (React.createElement("div", { className: 'SpinnerWidget ' +
            (0, SpinnerWidgetStyles_1.SpinnerWidgetStyles)() +
            extraClassName +
            sizeClassName, style: style },
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null)));
};
exports.SpinnerWidget = SpinnerWidget;
